.selected-location {
  height: 24px;
}
